import { useScreenSize } from '@hooks';
import { theme, Typography } from '@styles';
import { arrayOf, func, object } from 'prop-types';
import React from 'react';

import { CardButton } from './Card.layoutProps';

const Card = ({ card, onClick, selectedCards }) => {
  const { isMobile } = useScreenSize();

  const isSelected = selectedCards.some((item) => card?.id === item?.id);
  const isDisabled = selectedCards.length === 2;
  const isCorrect = selectedCards.some((item) => card?.id === item?.match_id);

  const calculateStyle = () => {
    if (isSelected) {
      if (!isCorrect && selectedCards.length === 2) {
        return {
          backgroundColor: theme.colors.red[20],
          borderColor: theme.colors.red[20],
          color: theme.colors.white[100],
        };
      }
      return {
        backgroundColor: theme.colors.schoolBusYellow[100],
        borderColor: theme.colors.schoolBusYellow[100],
        color: theme.colors.background,
      };
    }
    return {
      backgroundColor: theme.colors.hunterGreen[20],
      borderColor: theme.colors.whiteLine[100],
      color: theme.colors.white[100],
    };
  };

  return (
    <CardButton
      {...calculateStyle()}
      borderRadius={0}
      borderStyle="solid"
      borderWidth={1}
      disabled={isDisabled}
      height="auto"
      minHeight="148px"
      onClick={onClick}
      p={isMobile ? '8px' : 24}
      variant="textButton"
    >
      <Typography
        variant="MS-regular-s16-lh25"
        {...(isMobile && { wordBreak: 'break-word' })}
      >
        {card?.title}
      </Typography>
    </CardButton>
  );
};

Card.propTypes = {
  card: object.isRequired,
  onClick: func.isRequired,
  selectedCards: arrayOf(object).isRequired,
};

export default Card;
